import { Md5 } from 'md5-typescript';

export const isInExperiment = ({
  userId,
  experimentName,
  rolloutPercentage,
}: {
  userId: string;
  experimentName: string;
  rolloutPercentage: number;
}) => {
  if (!userId || rolloutPercentage <= 0) {
    return false;
  }

  const md = Md5.init(`${userId}.${experimentName}`);

  return parseInt(md.slice(-4), 16) % 100 < rolloutPercentage;
};
